<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Statutory Plant &amp; Utility Covers</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Air valves</li>
						<li>Cable TV inspection covers</li>
						<li>Cabinets (identified where possible)</li>
						<li>Electricity covers</li>
						<li>Electricity poles</li>
						<li>Fire hydrants</li>
						<li>Gas/water stop valves and stop cocks (cover)</li>
						<li>Inspection covers/manholes with level</li>
					</div>
					<div class="col md-6">
						<li>Lamp posts</li>
						<li>Marker posts</li>
						<li>Surveillance cameras</li>
						<li>Telecoms inspection covers</li>
						<li>Telegraph poles</li>
						<li>Telephone call boxes</li>
						<li>Water meter or gas meter covers (distinguished from valve)</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'StatutoryUtilitiesModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/StatutoryUtilitiesModal.vue